'use strict';

angular.module('teams').factory('TeamMembers', ['$resource',
    function($resource) {
        return $resource('v1/teams/:teamId/team-members/:teamMemberId', { teamId: '@_id', teamMemberId: '@_id'
        }, {
            update: {
                method: 'PUT'
            },
            getAll: {
				url: 'v1/teams/:teamId/team-members',
				method: 'GET',
				isArray: true
			},
        });
    }
]);